import React from "react";
import { Route, Routes } from "react-router";
import List from "./List";
import Add from "./Add";
import Edit from "./Edit";
import View from "./View";
import Applications from "./Applications";
import Details from "./Details";

const MyAds: React.FC = () => {
    return (
        <Routes>
            <Route index element={<List />} />
            <Route path="ajouter" element={<Add />} />
            <Route path=":id/details" element={<Details />} />
            <Route path=":id" element={<View />} />
            <Route path=":id/modifier" element={<Edit />} />
            <Route path=":id/candidatures" element={<Applications />} />
        </Routes>
    );
};

export default MyAds;
